import { fetch } from '@utils/utils';
import * as T from '@modules/jobs/_jobsTypes';

export const getJob = ({ addError }) => async (id: string): Promise<T.Job | {}> => {
  try {
    const response: any = await fetch(`/metropolis/api/jobs/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Job = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const getJobRun = ({ addError }) => async (runId: string, jobId: string): Promise<T.JobRun> => {
  try {
    const response: any = await fetch(`/metropolis/api/jobs/${jobId}/run/${runId}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.JobRun = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/modules/jobs/_jobsActions.ts